import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CardMedia,
    Container,
    Grid,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../../components/exports";
import { useTutorialContext } from "../../tutorialModule/TutorialContext";

// Memoized styles to prevent recreation on every render
const imageStyle = {
    width: "100%",
} as const;

const tutorialPoints = [
    "آشنایی با اصول فروش",
    "آشنایی با مهارت های ضروری فروش",
    "آشنایی با نکات کلیدی فروش",
] as const;

function PanelTutorials() {
    const theme = useTheme();
    const isSmallOrDownScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const { setActiveStep } = useTutorialContext();
    const navigate = useNavigate();

    const handleSetGeneralTutorial = useCallback(() => {
        navigate("/");
        setActiveStep(
            isSmallOrDownScreen ? "mobile-signup-1" : "desktop-signup-1"
        );
    }, [navigate, setActiveStep, isSmallOrDownScreen]);

    return (
        <Container maxWidth="lg">
            <PageHeader title="راهنمای کار با پنل" />

            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                    <Card>
                        <CardHeader
                            title="نکات کلیدی فروش"
                            action={
                                <Button onClick={handleSetGeneralTutorial}>
                                    مشاهده مجدد
                                </Button>
                            }
                        />
                        <CardMedia>
                            <img
                                src="/images/panel-tutorial-general.png"
                                alt="آموزش کار با پنل"
                                style={{ width: "100%" }}
                            />
                        </CardMedia>

                        <CardContent>
                            <Typography>نکات مهم و کلیدی برای فروش</Typography>
                            <Typography>
                                آشنایی به اصول و مهارت های ضروری فروش، قدم اول
                                در رشد و پیشرفت هر کسب و کاری است، با استفاده از
                                نکاتی که تیم ما پس از سال ها حضور در این صنعت به
                                دست آورده میتوانید فروش بیشتر و تجربه همکاری
                                بهتری با مجموعه پرشین سازه داشته باشید. نکاتی که
                                پس از این دوره با آنها آشنا خواهید شد:
                            </Typography>
                            <ul>
                                <li>آشنایی با اصول فروش</li>
                                <li>آشنایی با مهارت های ضروری فروش</li>
                                <li>آشنایی با نکات کلیدی فروش</li>
                            </ul>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
}

export default React.memo(PanelTutorials);
